export default __webpack_public_path__ + "static/nemecko-f7edd6a865fb658a5bbc3760c788631d.jpg";